import React from "react";
import { chatDataType } from "components/Messages/types";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "components/Messages/utils";

type props = {
  chat: chatDataType;
};

const ChatContainer = ({ chat }: props) => {
  const { t } = useTranslation();
  const content =
    chat.lastMessageContent.length > 25
      ? `${chat.lastMessageContent.slice(0, 25)}...`
      : chat.lastMessageContent;
  return (
    <>
      <div className="chatTitle">
        <div>{chat.volunteerFullName ?? t("guest")}</div>
        <div>{getFormattedDate(chat?.lastMessageDate)}</div>
      </div>
      <div
        className="chatContent"
        style={{ fontWeight: chat.isSeen ? "normal" : "bold" }}
      >
        <div>{content}</div>
        <div>
          {t("report")} {chat.reportId}
        </div>
      </div>
    </>
  );
};

export default ChatContainer;
